import React from "react";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import { ProgramType } from "../../../models/financing-request/ProgramType";
import ElementaryTeachingAidItem from "./ElementaryTeachingAidItem";
import HighTeachingAidItem from "./HighTeachingAidItem";
import { Grid } from "@material-ui/core";
import { SpecialNeedType } from "../../../models/special-need-type/SpecialNeedType";
import Currency from "../../../models/shared/Currency";
import AnnualAdministration from "../../../models/admin/annual-administration/AnnualAdministration";

interface Props {
  studentData: FinancingRequestStudentData;
  specialNeedType: SpecialNeedType;
  currency: Currency;
  annualPricing: AnnualAdministration;
  onChange: (e: any) => void;
}

export default function TeachingAidItem({
  studentData,
  specialNeedType,
  currency,
  annualPricing,
  onChange
}: Props) {
  function getTeachingAidComponent() {
    if (studentData.teachingAidOption) {
      switch (studentData.student.programType) {
        case ProgramType.Elementary:
          return (
            <ElementaryTeachingAidItem
              teachingAidOption={studentData.teachingAidOption}
              specialNeedType={specialNeedType}
              currency={currency}
              annualPricing={annualPricing}
              onChange={onChange}
              
            />
          );
        case ProgramType.High:
          return (
            <HighTeachingAidItem
              teachingAidOption={studentData.teachingAidOption}
              onChange={onChange}
            />
          );
        default:
          return null;
      }
    }
    return null;
  }

  return (
    <>
      <Grid container item xs={12} spacing={4} className="noMarginPadding">
        {getTeachingAidComponent()}
      </Grid>
    </>
  );
}
